import type { Work } from '@brent/shared/types'
import apiClient from './client'

export interface WorkPerformance {
  concert_id: number
  programme_item_id: number
  date_iso: string | null
  date_text: string | null
  year: number | null
  venue_name: string | null
  ensemble_name: string | null
  arrangement_note: string | null
  position: number
}

export interface WorkDetailResponse {
  work: Work
  performances: WorkPerformance[]
}

export interface UpdateWorkInput {
  quality_score?: string
  wikidata_id?: string
}

export interface UpdateWorkResponse {
  ok: boolean
  enriched?: {
    label: string
    description: string
    birth_year: number
    death_year: number
  }
  cleared?: boolean
  error?: string
}

export interface ReassignComposerInput {
  value: string
}

export interface ReassignComposerResponse {
  ok: boolean
  composer_name: string | null
  composer_qid: string | null
  created?: boolean
  unlinked?: boolean
  merged_into?: number
  error?: string
}

export async function fetchWork(id: number): Promise<WorkDetailResponse> {
  return apiClient.get<WorkDetailResponse>(`/works/${id}`)
}

export async function updateWork(id: number, input: UpdateWorkInput): Promise<UpdateWorkResponse> {
  return apiClient.put<UpdateWorkResponse>(`/works/${id}`, input)
}

export async function reassignComposer(
  workId: number,
  input: ReassignComposerInput,
): Promise<ReassignComposerResponse> {
  return apiClient.put<ReassignComposerResponse>(`/works/${workId}/composer`, input)
}
